import { colors } from './colors';

export type AppBarColorSet = {
  main: string;
  selectedNav: string;
  unselectedNav: string;
};

export const getAppBarColor = (): AppBarColorSet => {
  const env = process.env.NODE_ENV || 'development';

  // Check for specific environment variables that might be set
  if (process.env.REACT_APP_ENVIRONMENT) {
    switch (process.env.REACT_APP_ENVIRONMENT.toLowerCase()) {
    case 'dev':
    case 'development':
      return colors.appBar.development;
    case 'qa':
    case 'staging':
      return colors.appBar.qa;
    case 'prod':
    case 'production':
      return colors.appBar.production;
    default:
      return colors.appBar.development;
    }
  }

  // Fallback to NODE_ENV
  switch (env) {
  case 'development':
    return colors.appBar.development;
  case 'production':
    return colors.appBar.production;
  default:
    return colors.appBar.development;
  }
}; 
